module.exports = __webpack_public_path__ + "static/media/IMG-28519e9d5bebf28f57b0e084c28bcb42-V.2947b5e6.jpg";